import React from "react";
import { Box } from "@mui/material";
import { useTheme } from "@mui/material";
import {
    ResponsiveContainer,
    BarChart,
    Bar,
    Line,
    XAxis,
    YAxis,
    Tooltip,
    Legend,
    CartesianGrid
} from "recharts";

interface ChartProps {
    data: {
        month: string;
        actual: number;
        forecast: number;
    }[];
}

export const PerformanceChart: React.FC<ChartProps> = ({ data }) => {
    const theme = useTheme();

    return (
        <Box sx={{ width: "100%", height: 350 }} my={2}>
            <ResponsiveContainer width="100%" height="100%">
                <BarChart
                    data={data}
                    margin={{ top: 10, right: 20, left: 0, bottom: 40 }}
                    barCategoryGap="35%"
                >
                    <CartesianGrid
                        vertical={true}
                        horizontal={true}
                        strokeDasharray="0"
                        stroke={theme.palette.divider}
                    />
                    <XAxis
                        dataKey="month"
                        scale="band"
                        type="category"
                        tick={{ fontSize: 12, fill: theme.palette.text.secondary, dx: '50%' }}
                        axisLine={false}
                        tickLine={false}
                        interval={0}
                    />
                    <YAxis
                        tickFormatter={(v) => `${v / 1000}K`}
                        tick={{
                            fontSize: 12,
                            fill: theme.palette.text.secondary,
                        }}
                        axisLine={false}
                        tickLine={false}
                    />
                    <Tooltip
                        contentStyle={{
                            fontSize: 12,
                            borderRadius: 6,
                            padding: "8px 12px",
                        }}
                    />
                    <Legend
                        verticalAlign="bottom"
                        align="center"
                        iconType="circle"
                        wrapperStyle={{
                            fontSize: 13,
                            paddingTop: 10,
                        }}
                    />
                    <Bar
                        dataKey="actual"
                        fill={theme.palette.success.light}
                        name="Actual"
                        radius={[1, 1, 0, 0]}
                        barSize={60}
                        isAnimationActive={false} // disables bar animation (and hover fade)
                        activeBar={false}         // removes hover highlight background
                    />
                    <Line
                        type="monotone"
                        dataKey="forecast"
                        stroke={theme.palette.primary.main}
                        strokeWidth={3}
                        name="Forecast"
                        activeDot={{ r: 5 }}
                        dot={false}
                        connectNulls
                    />
                </BarChart>
            </ResponsiveContainer>
        </Box>
    );
};